// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarComments-cls1_Ize","cls2":"SidebarComments-cls2_U9d SidebarComments-cls1_Ize"};